import {Component, inject, Input, OnInit} from '@angular/core';
import {defaultAuthOptions} from "@nebular/auth";
import { ShareDataService } from '@signature-it/ngx-generic/services';

@Component({
    selector: 'device-filter',
    templateUrl: './device-filter.html',
    styleUrls: ['./device-filter.scss'],
    standalone: false
})
export class DeviceFilterComponent implements OnInit {

    @Input() device: string;
    sharedData: ShareDataService = inject(ShareDataService);

    ngOnInit() {
        this.initCurrentDeviceMode()
    }

    initCurrentDeviceMode(){
        if(this.device == 'mobile' && this.sharedData.isMobileMode()) return true;
        if(this.device == 'desktop' && !this.sharedData.isMobileMode()) return true;
    }
}
